export default __webpack_public_path__ + "static/Construction-Photo1-22817537adb0fa09eb347dbb15f62043.png";